<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 px-sm-4 pt-4>
        <v-layout wrap justify-center>
          <v-flex xs10 sm12 xl12 text-left text-uppercase>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 16px;
                color: #000000;
                letter-spacing: 1px;
              "
            >
              Edit Profile
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start pt-4>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Your First Name
            </span>
            <v-text-field
              ref="fullName"
              color="#828282"
              placeholder="First Name"
              outlined
              dense
              :rules="[rules.required]"
              v-model="firstname"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Your Last Name
            </span>
            <v-text-field
              ref="fullName"
              color="#828282"
              placeholder="Last Name"
              outlined
              dense
              :rules="[rules.required]"
              v-model="lastname"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Enter your Phone No
            </span>
            <v-text-field
              ref="phone"
              color="#828282"
              placeholder="Phone NO"
              outlined
              dense
              :rules="[rules.required]"
              v-model="phone"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Enter your email ID
            </span>
            <v-text-field
              ref="email"
              color="#828282"
              placeholder="Email ID"
              outlined
              dense
              :rules="emailRules"
              v-model="email"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Enter your Gender
            </span>
            <v-select
              outlined
              dense
              color="#828282"
              v-model="gender"
              :items="['Male', 'Female', 'Other']"
              placeholder="Gender"
              item-color="#ff0000"
              :rules="[rules.required]"
            >
              <template v-slot:item="{ item }">
                <span class="text-left pl-4">
                  {{ item }}
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Enter your Date of Birth
            </span>

            <v-menu
              ref="menu"
              v-model="datePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  color="#828282"
                  v-model="dob"
                  placeholder="Date of Birth"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="#3EA56E"
                ref="dob"
                v-model="dob"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
                @change="save"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 text-left px-sm-4>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
              >Enter your Location
            </span>
            <v-text-field
              ref="location"
              color="#828282"
              placeholder="Location"
              outlined
              dense
              v-model="location"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center py-6>
          <v-flex xs12 sm6 md6 lg4 xl3>
            <v-btn
              block
              tile
              color="#3EA56E"
              dark
              :ripple="false"
              depressed
              @click="editProfile"
            >
              <span
                style="
                  font-family: kumbhsansregular;
                  font-size: 16px;
                  text-transform: none;
                "
              >
                Update Profile
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      userId: null,
      firstname: null,
      lastname: null,
      phone: null,
      email: null,
      gender: null,
      dob: null,
      location: null,

      datePicker: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (value) => value.length >= 8 || "Min 8 characters",
        check: (confirmation) =>
          confirmation === this.password || "Passwords do not match",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userId = response.data.data._id;
            this.firstname = response.data.data.firstname;
            this.lastname = response.data.data.lastname;
            this.phone = response.data.data.phone;
            this.email = response.data.data.email;
            if (response.data.data.gender)
              this.gender = response.data.data.gender;
            if (response.data.data.dob)
              this.dob = new Date(response.data.data.dob)
                .toISOString()
                .substr(0, 10);
            if (response.data.data.locationname)
              this.location = response.data.data.locationname;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    validateInput() {
      if (!this.firstname) {
        this.msg = "Please provide first name";
        this.showSnackBar = true;
        return;
      }
      if (!this.lastname) {
        this.msg = "Please provide last name";
        this.showSnackBar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please provide your Phone Number";
        this.showSnackBar = true;
        return;
      }
      if (!this.email) {
        this.msg = "Please provide your email";
        this.showSnackBar = true;
        return;
      }
      this.editProfile();
    },
    editProfile() {
      var userData = {};
      userData["id"] = this.userId;
      userData["firstname"] = this.firstname;
      userData["lastname"] = this.lastname;
      userData["phone"] = this.phone;
      userData["email"] = this.email;
      userData["gender"] = this.gender;
      userData["dob"] = this.dob;
      userData["locationname"] = this.location;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/Edit",
        data: userData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$store.commit("userData", response.data.data);
            this.$router.push("/Profile");
          }
          this.msg = response.data.msg;
          this.showSnackBar = true;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>